"use strict";

Shopify.theme.jsStats = {
  init: function init($section) {
    // Add settings from schema to current object
    let _self = this;
    this.$section = $section;
    Shopify.theme.jsStats = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    ); // Selectors

    this.$nav = this.$section.find("[data-nav]");
    this.$navItems = this.$nav.find("[data-nav-item]");
    this.$preloadedImages = this.$section.find(".custom-preload");
    this.$slider = this.$section.find("[data-slider]").removeClass("is-hidden");

    this.createSlider();
  },
  createSlider: function () {
    this.slider = this.$slider.flickity({
      wrapAround: false,
      draggable: false,
      cellAlign: "center",
      initialIndex: this.initial_slide,
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: false,
    });

    this.$preloadedImages.each(function (i, image) {
      lazySizes.loader.unveil(image);
    });
    this.refresh();
    setTimeout(
      function () {
        this.refresh();
      }.bind(this),
      500
    );

    this.initListeners();
  },
  initListeners: function () {
    this.slider.on("change.flickity", this.updateNav.bind(this));
    this.$navItems.on("click", this.updateSlider.bind(this));
  },
  refresh: function () {
    this.slider.flickity("resize");
  },
  updateNav: function (e, index) {
    if (isNaN(index)) {
      index = $(e.target).data("index");
    }
    this.$navItems.removeClass("is-active");
    this.$navItems.eq(index).addClass("is-active");
  },
  updateSlider: function (e, index) {
    if (isNaN(index)) {
      index = $(e.target).data("index");
    }
    this.slider && this.slider.flickity("select", index, false, false);
  },
  blockSelect: function blockSelect($section, blockId) {
    let index = $("#shopify-section-" + blockId).data("index");
    this.updateNav(index);
    this.updateSlider(false, index);
  },
  unload: function unload($section) {},
};
